import {
    Grid,
    pxToRem,
    useStyles,
    useDeviceTypeContext,
} from '@archipro-design/aria';
import { useIsSafari } from '@modules/root/hook/use-is-safari';
import * as S from './ProjectEnquiryForm.style';
import type { CompanyProfileData } from '~/modules/company-profile/CompanyProfile';
import CompanyProfile from '~/modules/company-profile/CompanyProfile';

interface ProjectEnquiryFormProps {
    data: CompanyProfileData;
    showAddToDeisgnBoardInEnquiryForm?: boolean;
}

export const ProjectEnquiryForm = ({ data }: ProjectEnquiryFormProps) => {
    const isSafari = useIsSafari();
    const { css } = useStyles({ isSafari });
    const { mobile } = useDeviceTypeContext();

    return (
        <div className={css(S.ProjectEnquiryFormContainer)}>
            <Grid
                className={css(S.Grid)}
                columns={mobile ? '100%' : `${pxToRem(924)} 1fr`}
                rows="1"
            >
                <div className={css(S.Spacer)}></div>
                <CompanyProfile data={data} showViewProfile={true} />
            </Grid>
        </div>
    );
};
